import { Injectable, inject, NgZone } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Auth0LockService } from '../services/auth0-lock.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private auth0LockService = inject(Auth0LockService);
  private router = inject(Router);
  private ngZone = inject(NgZone);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {


    // Check if user is authenticated using Auth0 Lock service
    if (this.auth0LockService.isAuthenticated()) {
      return true;
    } else {
      console.log('AuthGuard: User not authenticated, redirecting to login');

      // Determine if this is a global route
      const isGlobalRoute = state.url.startsWith('/Global') || state.url.startsWith('/GlobalAdmin');

      // Redirect to appropriate login page with requested URL
      const loginUrl = isGlobalRoute ? 'LoginGlobal' : 'Login';
      this.ngZone.run(() => {
        this.router.navigate([loginUrl]);
      });


      return false;
    }
  }
}
